import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _find from 'lodash/find';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// Core components
import Tooltip from 'components/core/Tooltip';
// Models
import mParking from 'models/cpm/parking';
// Custom
import {
  cpmParkingDataShape, cpmPlanningDataShape, cpmParkingCategoryDataShape, cpmCustomerDataShape,
} from 'constants/PropTypesShapes';
import AppIcon from 'components/icons/AppIcon';
import WarningIcon from 'components/misc/WarningIcon';
import ParkingTooltipContent from './ParkingTooltipContent';

const ParkingStatusInfoIcon = ({
  parking, timezone, withInfoTooltip, plannings, parkingCategories, customer,
}) => {
  // Get parking status
  const {
    icon, color, value,
  } = mParking.status(parking);

  const finalColor = color;

  // Plannings from parking category
  const parkingCategory = _find(parkingCategories, ['id', mParking.getParkingCategoryId(parking, customer)]);
  const allotmentPlanning = parkingCategory ? _find(plannings, ['id', _get(parkingCategory.defaultAllotment, 'planning.id')]) : null;

  let parkingPlanning;
  // Check if parking is started or in progress
  if (mParking.isStarted(parking) || mParking.isInProgress(parking)) {
    // For these parkings, we need to check plannings to display a specific icon if any
    parkingPlanning = _get(parking, 'planning');
  }

  // Build icon
  const infoIcon = (
    <AppIcon
      id={icon}
      color={finalColor}
    />
  );
  const isBooking = mParking.isBooking(parking);
  const entryAndExitForbidden = parking.restrictedByForbiddenEntry && parking.restrictedByForbiddenExit;

  return (
    <div className="d-flex">
      <Tooltip
        light={withInfoTooltip}
        content={withInfoTooltip ? (
          <ParkingTooltipContent
            parking={parking}
            timezone={timezone}
            allotmentPlanning={allotmentPlanning}
            parkingPlanning={parkingPlanning ? _find(plannings, ['id', parkingPlanning.id]) : null}
            withHeaderMessage
          />
        ) : (
          <LocalizedMessage id="info.parkingStatusDesc" values={{ status: value }} />
        )}
      >
        {infoIcon}
      </Tooltip>
      {entryAndExitForbidden && (
        <div style={{ marginTop: '-6px', marginLeft: '-6px' }}>
          <WarningIcon iconSize="small" tooltipId={isBooking ? 'tooltip.entryAndExitForbiddenBooking' : 'tooltip.entryAndExitForbiddenAccessRight'} />
        </div>
      )}
      {!entryAndExitForbidden && parking.restrictedByForbiddenExit && (
        <div style={{ marginTop: '-6px', marginLeft: '-6px' }}>
          <WarningIcon iconSize="small" tooltipId={isBooking ? 'tooltip.exitForbiddenBooking' : 'tooltip.exitForbiddenAccessRight'} />
        </div>
      )}
      {!entryAndExitForbidden && parking.restrictedByForbiddenEntry && (
        <div style={{ marginTop: '-6px', marginLeft: '-6px' }}>
          <WarningIcon iconSize="small" tooltipId={isBooking ? 'tooltip.entryForbiddenBooking' : 'tooltip.entryForbiddenAccessRight'} />
        </div>
      )}
    </div>
  );
};

ParkingStatusInfoIcon.propTypes = {
  parking: cpmParkingDataShape.isRequired,
  timezone: PropTypes.string.isRequired,
  withInfoTooltip: PropTypes.bool,
  plannings: PropTypes.arrayOf(cpmPlanningDataShape),
  parkingCategories: PropTypes.arrayOf(cpmParkingCategoryDataShape).isRequired,
  customer: cpmCustomerDataShape,
};

ParkingStatusInfoIcon.defaultProps = {
  withInfoTooltip: false,
  plannings: null,
  customer: null,
};

const mapStateToProps = (state) => ({
  parkingCategories: state.cpmCarparkParkingCategory.list.elements,
  plannings: state.cpmCarparkPlanning.list.elements,
});

module.exports = connect(
  mapStateToProps,
)(ParkingStatusInfoIcon);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/parkings/ParkingStatusInfoIcon.js